export interface SaleUnitCartValidationResponseDto {
  success: boolean;
  msg: string;
}
